//LOGIN
export const ADMIN_LOGIN_REQUEST = "ADMIN_LOGIN_REQUEST";
export const ADMIN_LOGIN_SUCCESS = "ADMIN_LOGIN_SUCCESS";
export const ADMIN_LOGIN_FAIL = "ADMIN_LOGIN_FAIL";

//LOGOUT
export const ADMIN_LOGOUT = " ADMIN_LOGOUT";

//REGISTER
export const ADMIN_REGISTER_REQUEST = "ADMIN_REGISTER_REQUEST";
export const ADMIN_REGISTER_SUCCESS = "ADMIN_REGISTER_SUCCESS";
export const ADMIN_REGISTER_FAIL = "ADMIN_REGISTER_FAIL";

//REGISTER SUPER
export const ADMIN_REGISTER_SUPER_REQUEST = "ADMIN_REGISTER_SUPER_REQUEST";
export const ADMIN_REGISTER_SUPER_SUCCESS = "ADMIN_REGISTER_SUPER_SUCCESS";
export const ADMIN_REGISTER_SUPER_FAIL = "ADMIN_REGISTER_SUPER_FAIL";

//UPDATE DETAIL
export const ADMIN_UPDATE_DETAIL_REQUEST = "ADMIN_UPDATE_DETAIL_REQUEST";
export const ADMIN_UPDATE_DETAIL_SUCCESS = "ADMIN_UPDATE_DETAIL_SUCCESS";
export const ADMIN_UPDATE_DETAIL_FAIL = "ADMIN_UPDATE_DETAIL_FAIL";

//CHANGE PASSWORD
export const ADMIN_CHANGE_PASSWORD_REQUEST = "ADMIN_CHANGE_PASSWORD_REQUEST";
export const ADMIN_CHANGE_PASSWORD_SUCCESS = "ADMIN_CHANGE_PASSWORD_SUCCESS";
export const ADMIN_CHANGE_PASSWORD_FAIL = "ADMIN_CHANGE_PASSWORD_FAIL";

//UPDATE IMAGE
export const ADMIN_UPDATE_IMAGE_REQUEST = "ADMIN_UPDATE_IMAGE_REQUEST";
export const ADMIN_UPDATE_IMAGE_SUCCESS = "ADMIN_UPDATE_IMAGE_SUCCESS";
export const ADMIN_UPDATE_IMAGE_FAIL = "ADMIN_UPDATE_IMAGE_FAIL";

//RESEND_EMAIL
export const ADMIN_RESEND_EMAIL_REQUEST = "ADMIN_RESEND_EMAIL_REQUEST";
export const ADMIN_RESEND_EMAIL_SUCCESS = "ADMIN_RESEND_EMAIL_SUCCESS";
export const ADMIN_RESEND_EMAIL_FAIL = "ADMIN_RESEND_EMAIL_FAIL";

//ADMIN_ONBOARD_COMPLETE
export const ADMIN_ONBOARD_COMPLETE_REQUEST = "ADMIN_ONBOARD_COMPLETE_REQUEST";
export const ADMIN_ONBOARD_COMPLETE_SUCCESS = "ADMIN_ONBOARD_COMPLETE_SUCCESS";
export const ADMIN_ONBOARD_COMPLETE_FAIL = "ADMIN_ONBOARD_COMPLETE_FAIL";

//UPDATE OTP BY SMS
export const UPDATE_OPT_BY_SMS_REQUEST = "UPDATE_OPT_BY_SMS_REQUEST";
export const UPDATE_OPT_BY_SMS_SUCCESS = "UPDATE_OPT_BY_SMS_SUCCESS";
export const UPDATE_OPT_BY_SMS_FAIL = "UPDATE_OPT_BY_SMS_FAIL";

//RESEND_OTP_BY_SMS
export const RESEND_OTP_BY_SMS_REQUEST = "RESEND_OTP_BY_SMS_REQUEST";
export const RESEND_OTP_BY_SMS_SUCCESS = "RESEND_OTP_BY_SMS_SUCCESS";
export const RESEND_OTP_BY_SMS_FAIL = "RESEND_OTP_BY_SMS_FAIL";

//UPDATE OTP BY EMAIL
export const UPDATE_OPT_BY_EMAIL_REQUEST = "UPDATE_OPT_BY_EMAIL_REQUEST";
export const UPDATE_OPT_BY_EMAIL_SUCCESS = "UPDATE_OPT_BY_EMAIL_SUCCESS";
export const UPDATE_OPT_BY_EMAIL_FAIL = "UPDATE_OPT_BY_EMAIL_FAIL";

//RESEND_OTP_BY_EMAIL
export const RESEND_OTP_BY_EMAIL_REQUEST = "RESEND_OTP_BY_EMAIL_REQUEST";
export const RESEND_OTP_BY_EMAIL_SUCCESS = "RESEND_OTP_BY_EMAIL_SUCCESS";
export const RESEND_OTP_BY_EMAIL_FAIL = "RESEND_OTP_BY_EMAIL_FAIL";

//REGENERATE_TOKEN
export const REGENERATE_TOKEN_REQUEST = "REGENERATE_TOKEN_REQUEST";
export const REGENERATE_TOKEN_SUCCESS = "REGENERATE_TOKEN_SUCCESS";
export const REGENERATE_TOKEN_FAIL = "REGENERATE_TOKEN_FAIL";

//LOGIN_USING_TOKEN
export const LOGIN_USING_TOKEN_REQUEST = "LOGIN_USING_TOKEN_REQUEST";
export const LOGIN_USING_TOKEN_SUCCESS = "LOGIN_USING_TOKEN_SUCCESS";
export const LOGIN_USING_TOKEN_FAIL = "LOGIN_USING_TOKEN_FAIL";

//CHANGING_TOKEN
export const CHANGING_TOKEN_REQUEST = "CHANGING_TOKEN_REQUEST";
export const CHANGING_TOKEN_SUCCESS = "CHANGING_TOKEN_SUCCESS";
export const CHANGING_TOKEN_FAIL = "CHANGING_TOKEN_FAIL";

//CONFIRM_SIGN_UP_OPT_BY_SMS
export const CONFIRM_SIGN_UP_OPT_BY_SMS_REQUEST =
  "CONFIRM_SIGN_UP_OPT_BY_SMS_REQUEST";
export const CONFIRM_SIGN_UP_OPT_BY_SMS_SUCCESS =
  "CONFIRM_SIGN_UP_OPT_BY_SMS_SUCCESS";
export const CONFIRM_SIGN_UP_OPT_BY_SMS_FAIL =
  "CONFIRM_SIGN_UP_OPT_BY_SMS_FAIL";

//RESEND_SIGN_UP_OTP_BY_SMS
export const RESEND_SIGN_UP_OTP_BY_SMS_REQUEST =
  "RESEND_SIGN_UP_OTP_BY_SMS_REQUEST";
export const RESEND_SIGN_UP_OTP_BY_SMS_SUCCESS =
  "RESEND_SIGN_UP_OTP_BY_SMS_SUCCESS";
export const RESEND_SIGN_UP_OTP_BY_SMS_FAIL = "RESEND_SIGN_UP_OTP_BY_SMS_FAIL";
